import React, { Fragment } from 'react'
import {
  Box,
  Grid,
  Typography,
  Avatar,
  Paper,
  Button,
  FormControl,
  Select,
  MenuItem,
  IconButton
} from '@mui/material';
import { BsCreditCard } from 'react-icons/bs';
import { BiShareAlt, BiBarcodeReader } from 'react-icons/bi';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { FiArrowLeftCircle, FiCreditCard } from 'react-icons/fi';
import { useHistory } from "react-router-dom";
import Stepper from "../../components/Stepper";


const state = {

  session: '',

  sender: {
    name: 'Willy Chagas',
    email: 'chagaswc89@gmail.com',
    phone: {
      areaCode: '48',
      number: '991510980',
    },
    document: {
      type: 'CPF',
      value: '71783955082'
    },
  },

  shipping: {
    type: 3,
    cost: 10.00,
    street: 'Av Campeche',
    number: 1111,
    complement: 'Casa',
    district: 'Campeche',
    city: 'Florianopolis',
    state: 'SC',
    country: 'BRA',
    postalCode: '88063789'
  },

  billing: {
    street: 'Av Campeche',
    number: 1111,
    complement: 'Casa',
    district: 'Campeche',
    city: 'Florianopolis',
    state: 'SC',
    country: 'BRA',
    postalCode: '88063789'
  },

  items: [
    {
      id: 1,
      description: 'Produto 1',
      quantity: 2,
      amount: 2,
    },
    {
      id: 2,
      description: 'Produto 2',
      quantity: 1,
      amount: 60.00,
    },
    {
      id: 3,
      description: 'Produto 3',
      quantity: 2,
      amount: 20.00,
    }
  ],

  creditCard: {
    maxInstallmentNoInterest: 5
  },
  extraAmount: 10.00,
  reference: 'Teste Pagseguro React'
}


const paymentMethods = [
  { key: 'Cartao Credito', label: 'Cartao Credito', icon: <BsCreditCard size={20} />, handler: 'handleCartaoCredito' },
  { key: 'Cartao Debito', label: 'Cartao Debito', icon: <BsCreditCard size={20} />, handler: 'handleCartaoDebito' },
  { key: 'Link Pagamento', label: 'Link Pagamento', icon: <BiShareAlt size={20} />, handler: 'handleLinkPagamento' },
  { key: 'Boleto', label: 'Boleto Bancario', icon: <BiBarcodeReader size={20} />, handler: 'handleBoleto' },
  { key: 'Dinheiro', label: 'Dinheiro', icon: <RiMoneyDollarCircleLine size={20} />, handler: 'handleDinheiro' },
];

const paymentMessages = {
  'Cartao Credito': 'Apos a confirmacao do pedido, sera gerado um codigo para ser inserido no App Katuxa Pay para que o pagamento com o cliente seja concluido',
  'Cartao Debito': 'Apos a confirmacao do pedido, sera gerado um codigo para ser inserido no App Katuxa Pay para que o pagamento com o cliente seja concluido',
  'Boleto': 'Apos a confirmacao do pedido, sera gerado um boleto para pagamento',
  'Link Pagamento': 'Apos a confirmacao do pedido, sera gerado um link de pagamento da Yapay. Este link pode ser compartilhado com o cliente para que ele possa efetuar o pagamento de um modo seguro',
  'Dinheiro': 'Apos a confirmacao do pedido, dirija-se com o cliente ate o caixa para pagamento do pedido.',
};


const PagamentoPage = () => {

  const [tipoPagamento, setTipoPagamento] = React.useState('');
  const [bandeira, setBandeira] = React.useState('');
  const history = useHistory();

  const handleChange = (event) => {
    setBandeira(event.target.value);
  };

  const handleCartaoDebito = () => {
    setTipoPagamento('Cartao Debito')
  }

  const handleCartaoCredito = () => {
    setTipoPagamento('Cartao Credito')
  }

  const handleBoleto = () => {
    setTipoPagamento('Boleto')
  }

  const handleDinheiro = () => {
    setTipoPagamento('Dinheiro')
  }

  const handleLinkPagamento = () => {
    setTipoPagamento('Link Pagamento')
  }

  const voltarPdv = () => {
    history.push('cadastro')
  }

  const handleMethodClick = {
    'Cartao Credito': handleCartaoCredito,
    'Cartao Debito': handleCartaoDebito,
    'Link Pagamento': handleLinkPagamento,
    'Boleto': handleBoleto,
    'Dinheiro': handleDinheiro,
  };

  const needsBandeira = tipoPagamento === 'Cartao Debito' || tipoPagamento === 'Cartao Credito';

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', maxWidth: '98%', mx: 'auto' }}>
        <Box sx={{ py: 2, px: { xs: 2, md: 3 }, display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton onClick={voltarPdv} sx={{ color: '#1a1a2e' }}>
            <FiArrowLeftCircle size={28} />
          </IconButton>
          <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', mr: 2 }}>Voltar</Typography>
          <Box sx={{ flex: 1 }}>
            <Stepper valorStep={3} />
          </Box>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        {/* Section Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
            <FiCreditCard size={18} />
          </Avatar>
          <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
            Selecione a forma de pagamento
          </Typography>
        </Box>

        {/* Payment Method Cards */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {paymentMethods.map((method) => (
            <Grid item xs={6} sm={4} md={2} key={method.key}>
              <Paper
                onClick={handleMethodClick[method.key]}
                sx={{
                  p: { xs: 2, md: 2.5 },
                  borderRadius: 2.5,
                  border: '2px solid',
                  borderColor: tipoPagamento === method.key ? '#1a1a2e' : 'grey.200',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                  bgcolor: tipoPagamento === method.key ? '#f0f1f5' : '#fff',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    borderColor: '#1a1a2e',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ color: '#1a1a2e' }}>{method.icon}</Box>
                  <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                    {method.label}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Payment Details */}
        {tipoPagamento && (
          <Paper sx={{
            p: { xs: 2.5, md: 3 },
            borderRadius: 2.5,
            border: '1px solid',
            borderColor: 'grey.200',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            bgcolor: '#fff'
          }}>
            {needsBandeira && (
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontWeight: 600, mb: 1.5 }}>
                  Escolha a bandeira do Cartao
                </Typography>
                <FormControl variant="outlined" size="small" sx={{ minWidth: 220 }}>
                  <Select
                    value={bandeira}
                    onChange={handleChange}
                    displayEmpty
                    sx={{
                      borderRadius: 1.5,
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#1a1a2e'
                      }
                    }}
                  >
                    <MenuItem value=""><em>Selecione</em></MenuItem>
                    <MenuItem value={10}>Visa</MenuItem>
                    <MenuItem value={20}>Mastercard</MenuItem>
                    <MenuItem value={30}>Elo</MenuItem>
                    <MenuItem value={40}>American Express</MenuItem>
                    <MenuItem value={50}>Diners</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}

            {(!needsBandeira || bandeira) && (
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  Forma de Pagamento: <Box component="span" sx={{ fontWeight: 800 }}>{tipoPagamento}</Box>
                </Typography>
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                  {paymentMessages[tipoPagamento]}
                </Typography>
              </Box>
            )}
          </Paper>
        )}
      </Box>
    </Box>
  )
}

export default PagamentoPage;
